export function RequiredAsterisk() {
  return (
    <>
      <span aria-hidden="true" className="ml-0.5 text-redline">
        *
      </span>
      <span className="sr-only"> (required)</span>
    </>
  );
}